import { render } from "./ModalBranch.vue?vue&type=template&id=c034137c"
import script from "./ModalBranch.vue?vue&type=script&lang=js"
export * from "./ModalBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__